// extracted by mini-css-extract-plugin
module.exports = {"page":"css-specificity-calculator-styles-module--page--250a0"};